<template>
  <store-recherche-provider v-if="mountedEndLoading"
    key="listeFacturesClient"
    :name="constantes.storeName"
    :copy="factureStore"
    :isTemporary="true"
    :copyChanges="changesFactureStore()">
    <liste-factures
      :nameStore="constantes.storeName"
      :tiersId="tiersInformation.id"
      :referenceTable="constantes.referenceTable"/>
  </store-recherche-provider>
</template>

<script>
import factureStore, { initialState } from '@/store/modules/facture';
import listeFactures from '@/components/factures/liste/listeFactures';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import { REFERENCE_TABLE_FACTURE_CLIENT } from '@/configuration/general/referenceTableConf';
import { FACTURE_CLIENT_STORE_NAME } from '@/configuration/tiers/tiersConf';
import { getWithLiensInferieurs } from '@/api/tiers/index';

export default {
  name: 'ListeFactureClient',
  components: {
    storeRechercheProvider,
    listeFactures,
  },
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      factureStore,
      constantes: {
        storeName: FACTURE_CLIENT_STORE_NAME,
        referenceTable: REFERENCE_TABLE_FACTURE_CLIENT,
      },
      targetTiers: [],
      mountedEndLoading: false,
    };
  },
  methods: {
    async getAllTiers() {
      const lien = (await getWithLiensInferieurs(this.tiersInformation.id, true)).data.result;
      const clients = [lien];

      if (lien.tiersEnfants?.length > 0) {
        const enfants = lien.tiersEnfants.map(te => {
          return te.tiersEnfants?.length > 0 ? [te, te.tiersEnfants] : [te];
        });
        clients.push(...enfants);
      }
      return clients.flat(2);
    },
    changesFactureStore() {
      const vm = this;
      const initialStateFunc = () => {
        const initialStateObject = initialState();
        initialStateObject.criteresRecherche.clients = vm.targetTiers;
        return initialStateObject;
      };

      return {
        state: initialStateFunc(),
        mutations: {
          RESET_CRITERE(state) {
            state.criteresRecherche = initialStateFunc().criteresRecherche;
          },
          RESET_STATE(state) {
            const s = initialStateFunc();
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  async mounted() {
    this.targetTiers = await this.getAllTiers();
    this.mountedEndLoading = true;
  },
};
</script>
